export default __webpack_public_path__ + "static/media/sector-production.497cb97c.png";